import type { PcmFrame } from '@/speech/contracts';

// Only local, bounded pre-roll. Dropped frames never leave the browser unless
// the acoustic detector confirms a new speaker; normal playback completion or
// a tap discards them. Copy because capture/socket transports can transfer PCM.
export function createVoiceCaptureGate(now: () => number) {
  let prefix: { frame: PcmFrame; at: number }[] = [];
  return {
    push(frame: PcmFrame, open: boolean, send: (frame: PcmFrame) => void) {
      if (open) {
        prefix = [];
        send(frame);
      } else {
        prefix.push({ frame: { ...frame, pcm: frame.pcm.slice(0) }, at: now() });
        if (prefix.length > 2) prefix.shift();
      }
    },
    release(since: number, send: (frame: PcmFrame) => void) {
      const frames = prefix;
      prefix = [];
      // Activity is reported every 20 ms; retain only the frame that can
      // contain this onset, never older playback-only pre-roll.
      frames.filter(({ at }) => at >= since - 20).forEach(({ frame }) => send(frame));
    },
    clear() {
      prefix = [];
    },
  };
}
